<template>
  <div class="flex bg-[#F7F8FB] rounded-md">
    <OLink :href="articleUrl" class="flex-1 p-4">
      <h2 class="text-md font-medium">{{ comment.article.title }}</h2>
      <div class="mt-2 text-primary-200 text-md font-normal">{{ comment.text }}</div>
      <div class="text-primary-300 text-sm font-medium flex items-center mt-2.5">
        <OIcon icon="like" class="mr-0.5 -ml-0.5" />
        <span class="mr-2">{{ comment.ratings.likes }} {{ $t('profile.like') }}</span>
        <time>{{ commentDate }}</time>
      </div>
    </OLink>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { getDateWithTime } from '~/modules/common/utils/dateUtils';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  name: 'CommentCardProfile',
  components: { OLink, OIcon },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  setup({ comment }) {
    const commentDate = computed(() => {
      if (!comment.dates?.created) return null;
      return getDateWithTime(comment.dates?.created);
    });
    const articleUrl = computed(() => {
      return getArticleUrl({ article: comment.article });
    });
    return {
      articleUrl,
      commentDate,
    };
  },
});
</script>
